import { X } from 'lucide-react'
import React from 'react'

interface SaveWorkflowModalProps {
  isEditing?: boolean
  showSaveModal: boolean
  saveAction: 'draft' | 'final'
  isSaving: boolean
  workflowName?: string
  workflowDescription?: string
  onSave: (name: string, description: string) => void
  onCancel: () => void
}

const SaveWorkflowModal: React.FC<SaveWorkflowModalProps> = ({
  showSaveModal,
  isEditing,
  saveAction,
  isSaving,
  workflowName,
  workflowDescription,
  onSave,
  onCancel
}) => {
  if (!showSaveModal) return null

  const handleSave = () => {
    const name = (document.getElementById('workflowName') as HTMLInputElement)?.value
    const description = (document.getElementById('workflowDescription') as HTMLTextAreaElement)?.value

    if (!name || name.trim() === '') {
      return
    }

    onSave(name.trim(), description.trim())
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="relative bg-white rounded-lg p-6 w-full max-w-md dark:bg-zink-600">
        <h3 className="text-lg font-medium mb-4 text-slate-800 dark:text-zink-50">
          {saveAction === 'draft' ? 'Save as Draft' : 'Save Workflow'}
        </h3>
        <span onClick={onCancel} className='absolute top-4 right-4 hover:text-slate-600'><X /></span>

        {isSaving ? (
          <div className="flex flex-col items-center justify-center py-8">
            <div className="w-8 h-8 border-4 border-custom-500 border-t-transparent rounded-full animate-spin mb-4"></div>
            <p className="text-slate-600 dark:text-zink-200">
              {saveAction === 'draft' ? 'Saving draft...' : 'Saving workflow...'}
            </p>
          </div>
        ) : (
          <>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-zink-200 mb-1">
                  Workflow Name *
                </label>
                <input
                  type="text"
                  defaultValue={isEditing ? workflowName : ''}
                  className="w-full px-3 py-2 border border-slate-300 rounded-md dark:border-zink-500 dark:bg-zink-700 dark:text-zink-50"
                  placeholder="Enter workflow name"
                  id="workflowName"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-zink-200 mb-1">
                  Description
                </label>
                <textarea
                  defaultValue={isEditing ? workflowDescription : ''}
                  className="w-full px-3 py-2 border border-slate-300 rounded-md dark:border-zink-500 dark:bg-zink-700 dark:text-zink-50"
                  rows={3}
                  placeholder="Enter workflow description"
                  id="workflowDescription"
                />
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={onCancel}
                className="flex-1 px-4 py-2 bg-slate-500 text-white rounded-lg hover:bg-slate-600 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="flex-1 px-4 py-2 bg-custom-500 text-white rounded-lg hover:bg-custom-600 transition-colors"
              >
                {saveAction === 'draft' ? 'Save Draft' : 'Save Workflow'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default SaveWorkflowModal
